if (!customElements.get('c-collection-products')) {
  customElements.define(
    'c-collection-products',
    class CustomCollectionProducts extends HTMLElement {
      constructor() {
        super();

        this.splide = new Splide(this, {
          arrows: false,
          drag: true,
          keyboard: true,
          rewind: true,
          pagination: false,
          perPage: 1,
          mediaQuery: 'min',
          gap: 'var(--spacing-5)',
          padding: 'var(--spacing-6)',
          autoWidth: true,
          focus: 'center',
          breakpoints: {
            750: {
              perPage: 3,
              autoWidth: false,
              padding: 'var(--spacing-10)',
            },
            900: {
              type: 'loop',
              arrows: true,
              perPage: 4,
              padding: 0,
              focus: 1,
            },
          },
        });

        this.splide.mount();
      }

      connectedCallback() {
        if (Shopify.designMode) {
          const ids = [...this.splide.root.querySelectorAll('.splide__slide')].map((el) => el.dataset.blockId);

          this.addEventListener('shopify:block:select', (event) => {
            if (ids.includes(event.detail.blockId)) {
              this.splide.go(ids.indexOf(event.detail.blockId));
            }
          });
        }
      }
    }
  );
}
